import React, { VFC } from 'react';
import { makeStyles } from '@dxb-web-ui-framework/design-system';
import { GenericDrawer } from '../../../../content-composer/src/components/Generic/GenericDrawer';
import { ApproveRejectPayrollFlowPresenter } from './ApproveRejectPayrollFlowPresenter';

export interface ApproveRejectPayrollDrawerProps {
  isOpen: boolean;
  onToggle: () => void;
  authAction: string | null;
  showPayrollInfo?: boolean;
}

const useStyles = makeStyles(theme => ({
  drawerBodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
  },
}));

const ApproveRejectPayrollDrawer: VFC<ApproveRejectPayrollDrawerProps> = ({ isOpen, onToggle, authAction }) => {
  const classes = useStyles();

  if (!authAction) {
    return null;
  }

  return (
    <GenericDrawer
      anchor='bottom'
      title=''
      isOpen={isOpen}
      stickDrawerTitleToLeft
      disableMobileDrawerHeight
      onToggleDrawer={onToggle}
      customDrawerBodyClass={classes.drawerBodyContainer}>
      <ApproveRejectPayrollFlowPresenter authAction={authAction} onToggleDrawer={onToggle} />
    </GenericDrawer>
  );
};

export { ApproveRejectPayrollDrawer };
